import { render, staticRenderFns } from "./company-index.vue?vue&type=template&id=0da5450e&scoped=true"
import script from "./company-index.vue?vue&type=script&lang=js"
export * from "./company-index.vue?vue&type=script&lang=js"
import style0 from "./company-index.vue?vue&type=style&index=0&id=0da5450e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5450e",
  null
  
)

export default component.exports